import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

const PdfQrGenerator = () => {
  const [pdfUrl, setPdfUrl] = useState(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      // Create temporary URL for uploaded PDF
      const url = URL.createObjectURL(file);
      setPdfUrl(url);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const downloadQR = () => {
    const canvas = document.querySelector("canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "pdf_qr.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h2>Upload PDF & Generate QR Code</h2>
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileUpload}
        style={{
          margin: "20px 0",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
        }}
      />

      {pdfUrl && (
        <div style={{ marginTop: "20px" }}>
          <p>Scan this QR to open your uploaded PDF:</p>
          <div
            style={{
              background: "#fff",
              display: "inline-block",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            }}
          >
            <QRCodeCanvas
              value={pdfUrl}
              size={200}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <button
              onClick={downloadQR}
              style={{
                padding: "10px 20px",
                border: "none",
                borderRadius: "8px",
                background: "#007bff",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Download QR Code
            </button>
          </div>

          <div style={{ marginTop: "30px" }}>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              👉 Open Uploaded PDF
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default PdfQrGenerator;
